import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../components/commentBox";
import TaskCheckedList from "../../../components/taskCheckedList";
import PageHeader from "../../../components/pageHeader";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function CompleteMovein({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Complete move in" />
          </Col>
          <Col span={24}>
            <h3 className="yellow-info-text">
              Send this message to the property owner in appfolio -{" "}
              <span className="red-info-heading">
                include the address in the subject line
              </span>
            </h3>
          </Col>
          <Col span={24}>
            <p>
              This email is to notify you that the move in for your unit at the
              above address is complete. Please let us know if you have any
              questions. I have included a link to our new and updated owners
              manual here that also may help to answer some basic questions you
              may have along the way.
            </p>
          </Col>
          <Col span={24}>
            <p>
              https://docs.google.com/document/d/16EdTCDuEX_MrgbjHQvIpBTawkMSaYSR9c4-ogVcgPaQ/edit?usp=sharing
            </p>
          </Col>
          <Col span={24}>
            <p className="green-info-text">
              Send this message to the tenant in appfolio
            </p>
          </Col>
          <Col span={24}>
            <p>
              Welcome to your new home ! We are so excited about your move in,
              and I wanted to take some time to check in and provide you with
              the our methods of contact and to make sure the place is in
              expected conditions.
            </p>
          </Col>
          <Col span={24}>
            <p>
              For any questions concerns, please feel free to text (251)577-4036
              or call (405)283-6521; or email your Property Manager -{" "}
              <span className="onclick-text">Email Addresses</span>.
            </p>
          </Col>
          <Col span={24}>
            <p>A few reminders:</p>
            <ul>
              <li>
                <p>
                  Remember to submit any non-emergency maintenance requests
                  through the portal provided and these will be addressed as
                  soon as possible within business hours. If the work order is
                  urgent still submit in your portal but also text us at
                  251-577-4036
                </p>
              </li>
              <li>
                <p>
                  For assistance or questions on where to make payments, please
                  contact the Integrity Oklahoma team.
                </p>
              </li>
            </ul>
          </Col>
          <Col span={24}>
            <p>
              Feel free to reach out if you have any questions or concerns and
              be sure to let me know if there is anything else I can assist you
              with.
            </p>
          </Col>
          <Col span={24}>
            <p>Happy Move Info</p>
          </Col>
          <Col span={24}>
            <p>
              - The Integrity Oklahoma TeamSend this message to the tenant in
              appfolio
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default CompleteMovein;
